import { createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3106184f")

_pushScopeId("data-v-3106184f")
const _hoisted_1 = {
  class: "df-middle t-center px-8 shadow",
  style: {"height":"32px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "c-grey mx-6" }, "|", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-grey mx-6" }, "|", -1)
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-grey mx-6" }, "|", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Text Editor")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-grey mx-6" }, "|", -1)
const _hoisted_8 = {
  class: "p-a bg-white mt-4 shadow pl-4 py-4",
  style: {"width":"148px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", {
    class: "mask spread",
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
  }, [
    _createVNode("div", {
      style: {top: _ctx.y - 40 + 'px', left: _ctx.x ? _ctx.x + 'px' : '50%' },
      class: ["drawing-dialog p-a", {'bar': _ctx.type <= _ctx.LineType.TREND}]
    }, [
      _createVNode("div", _hoisted_1, [
        ([_ctx.LineType.LINE, _ctx.LineType.TREND, _ctx.LineType.TEXT].indexOf(_ctx.type)>-1)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "flex-1",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isPicking = !_ctx.isPicking), ["stop"])),
              style: {"min-width":"30px"}
            }, [
              _createVNode("span", {
                class: "color-label sm",
                style: {background: _ctx.cColor}
              }, null, 4),
              _createVNode(_component_Icon, {
                name: "caret-down",
                class: "ml-4 c-tip",
                sm: ""
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.alertOn !== null)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_2,
              _createVNode("div", {
                class: "flex-1",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAlert && _ctx.toggleAlert(...args)), ["stop"]))
              }, [
                _createVNode(_component_Pic, {
                  src: `icons/alert${_ctx.alertOn ? '' : '_off'}`,
                  width: "16",
                  height: "16"
                }, null, 8, ["src"])
              ]),
              _hoisted_3
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.LineType.TEXT)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_t, {
                path: "",
                class: "f-sm px-6",
                onClick: _withModifiers(_ctx.editText, ["stop"])
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "flex-1",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('remove')), ["stop"]))
        }, [
          _createVNode(_component_Pic, {
            src: "icons/delete",
            width: "16",
            height: "16"
          })
        ])
      ]),
      _withDirectives(_createVNode("ul", _hoisted_8, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item) => {
          return (_openBlock(), _createBlock("li", {
            key: item,
            style: {background: item},
            class: "color-label m-4",
            onClick: _withModifiers(($event: any) => (_ctx.pickColor(item)), ["stop"])
          }, null, 12, ["onClick"]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.isPicking]
      ])
    ], 6)
  ]))
})